<template>
  <div class="page px-3" v-if="visible">
    <div>
      <h4 class="function-title">Libre Deuda</h4>
    </div>
    <b-row>
      <b-col sm="8" offset-sm="2">
        <b-row>
          <b-col sm="12">
            <p>
              <b class="text-primary">Póliza:</b>
              {{ nroPoliza }}
            </p>
          </b-col>
          <b-col sm="12">
            <p class="text-primary">
              <b>Nro de Ítem / Nombre:</b>
              <!-- <b-form-select
                class="mt-2"
                :options="asegurados"
                v-model="asegurado"
                :disabled="onlytomador"
              /> -->
              <v-select
                class="mt-2"
                :options="asegurados"
                v-model="asegurado"
                :disabled="onlytomador"
                label="text"
              ></v-select>
            </p>
            <b-col sm="12">
              <b-form-checkbox :disabled="asegurados.length < 1" v-model="onlytomador" title="Se emitira el libre deuda para el tomador.">Emite al tomador</b-form-checkbox>
          </b-col>
          </b-col>
        </b-row>
        <div class="submit-footer">
          <b-row>
            <b-col></b-col>
            <b-col class="text-right">
              <b-btn
                variant="primary"
                @click="genLibreDeuda"
                :disabled="!asegurado && !onlytomador"
              >
                <i class="fa fa-check" v-if="!sending"></i>
                <i class="fa fa-spinner fa-spin" v-else></i>
                Generar Libre Deuda
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'GenLibreDeudaComponent',
  props: {
    nroPoliza: {
      type: Number | String
    },
    codAseg: {
      type: Number | String
    },
    tomador: {
      type: Number | String
    },
    nroEndoso: {
      type: Number | String
    },
    ramo: {
      type: Number | String
    },
    grupal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      asegurados: [],
      asegurado: '',
      sending: false,
      onlytomador: false
    };
  },
  methods: {
    genLibreDeuda() {
      //console.log(this.asegurado);
      let loading = this.$loading.show();

      this.$api({
        url: `endoso/libre-deuda`,
        method: 'POST',
        data: {
          nro_pol: this.nroPoliza,
          cod_ramo: this.ramo,
          cod_tomador: this.tomador,
          nro_endoso: this.nroEndoso,
          cod_aseg: this.asegurado?this.asegurado.value[0]:null,
          onlytomador: this.onlytomador
        },
        responseType: 'blob'
      })
        .then(res => {
          const fileURL = URL.createObjectURL(res.data);
          loading.hide();
          window.open(fileURL);
        })
        .catch(err => {
          loading.hide();
          const toast = this.$toast;
          const fr = new FileReader();
          fr.onload = function() {
            toast.error(fr.result.replace(/"/g, ''));
          };
          fr.readAsText(err.response.data);
        });
    }
  },
  watch: {
    visible(val) {
      if (val) {
        let loading = this.$loading.show();
        this.$api(`polizas/asegurados/${this.nroPoliza}/${this.nroEndoso}`)
            .then(res => {
                    loading.hide();
                    this.asegurados = res.data.map(item => ({
                      text: 'Aseg. Nro.: ' + item.nro_item + ' | Doc.: ' + item.documento + ' | Nombre: ' + item.nombre,
                      value: [item.cod_aseg, item.nro_item]            
                    })
                  );

          /** Selecciono asegurado x defecto */
          if (this.asegurados.length > 0) {
            this.asegurado = this.asegurados[0];
          } else if (this.asegurados.length<1) { this.onlytomador=true; }
        });
      }
    }
  }
};
</script>
